// extracted by mini-css-extract-plugin
export default {"cls1":"XW8tU3bQSwjQjGzGzpj6","cls2":"LqzwtPtfqT2tIGtyWTwp XW8tU3bQSwjQjGzGzpj6"};